@if (isMenu) {
  @if (showButton) {
    <button mat-menu-item [attr.aria-label]="'forwardAsAttachment' | translate">
      <div class="item-menu-center">
        <span class="material-symbols-outlined">
          forward
        </span>
        {{ 'forwardAsAttachment' | translate }}
      </div>
    </button>
  }
} @else {
  <app-loading-icon-button
    label="forwardAsAttachment"
    icon="forward"
    classIcon="material-symbols-outlined"
    [showButton]="showButton"
    [disabled]="disabled"
    [showLoading]="showLoading"
  ></app-loading-icon-button>
}
